import styled from "styled-components";

export const InputCheckboxLabel = styled.label`
  width: fit-content;
  display: flex;
  gap: 16px;
  height: fit-content;

  > span {
    color: #9d9d9d;
    text-align: center;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    transition: color 0.2s ease-in-out;
  }

  &:has(input:checked) > span {
    color: #111111;
  }
`;

export const InputCheckboxWrapper = styled.div`
  position: relative;

  > input {
    position: absolute;
    opacity: 0;
  }

  &::before {
    content: "";
    display: block;
    width: 24px;
    height: 12px;
    border: 3px solid #9d9d9d;
    border-radius: 8px;
    position: absolute;
    cursor: pointer;
    transition: border 0.2s ease-in-out;
  }

  &::after {
    content: "";
    position: absolute;
    display: block;
    width: 10px;
    height: 10px;
    bottom: 0;
    transform: translateY(-50%);
    cursor: pointer;
    left: 4px;
    background-color: #9d9d9d;
    border-radius: 50%;
    transition: left 0.2s ease-in-out;
  }

  &:has(input:checked)::before {
    border: 3px solid #111111;
  }

  &:has(input:checked)::after {
    left: 16px;
    background-color: #111111;
  }
`;
